/** @jsx jsx */
import { css, jsx, keyframes } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import { SpinnerIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/compound-assessments';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const styles = {
  container: () => css`
    display: flex;
    align-items: center;
    margin: var(--cds-spacing-200) 0;
  `,
  icon: () => css`
    margin-right: var(--cds-spacing-100);
    animation: ${rotate} 2s infinite linear;
  `,
};

export const RenderPreviewLoading: React.FC = () => {
  return (
    <div css={styles.container}>
      <SpinnerIcon css={styles.icon} color="support" />
      <Typography2 color="supportText" component="span">
        {_t('Loading preview')}
      </Typography2>
    </div>
  );
};

export default RenderPreviewLoading;
